import { observer } from "mobx-react-lite";
import { Button, Modal } from "@heroui/react";
import { helpSettingsStore } from "@/stores/HelpSettingsStore";

const HelpSettingsModals: React.FC = observer(() => {
  const { deleteTarget, isDeleting, discardIntent } = helpSettingsStore;

  const discardText =
    discardIntent?.kind === "tab"
      ? "Есть несохранённые изменения. Переключить вкладку без сохранения?"
      : discardIntent?.kind === "back"
        ? "Есть несохранённые изменения. Уйти со страницы без сохранения?"
        : "Есть несохранённые изменения. Закрыть без сохранения?";

  const handleDiscardDismiss = () => {
    helpSettingsStore.dismissDiscard();
  };

  return (
    <>
      <Modal.Backdrop
        isOpen={deleteTarget != null}
        onOpenChange={(open) => {
          if (!open) helpSettingsStore.cancelDelete();
        }}
        className="help-settings-modal-backdrop"
      >
        <Modal.Container>
          <Modal.Dialog>
            <Modal.CloseTrigger />
            <Modal.Header>
              <Modal.Heading>
                {deleteTarget?.kind === "executor"
                  ? "Удалить исполнителя?"
                  : "Удалить услугу?"}
              </Modal.Heading>
            </Modal.Header>
            <Modal.Body>
              <p className="help-settings-delete__text">
                {deleteTarget?.kind === "executor"
                  ? `${deleteTarget.label} исчезнет из справочника. В уже назначенных заявках данные останутся.`
                  : `${deleteTarget?.label ?? "Услуга"} исчезнет из каталога. Уже добавленные в заявки позиции останутся в чеке.`}
              </p>
            </Modal.Body>
            <Modal.Footer className="help-settings-footer">
              <Button
                variant="ghost"
                onPress={() => helpSettingsStore.cancelDelete()}
                isDisabled={isDeleting}
              >
                Отмена
              </Button>
              <Button
                variant="danger"
                onPress={() => void helpSettingsStore.confirmDelete()}
                isPending={isDeleting}
              >
                Удалить
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>

      <Modal.Backdrop
        isOpen={discardIntent != null}
        onOpenChange={(open) => {
          if (!open) handleDiscardDismiss();
        }}
        className="help-settings-modal-backdrop"
      >
        <Modal.Container>
          <Modal.Dialog>
            <Modal.CloseTrigger />
            <Modal.Header>
              <Modal.Heading>Несохранённые изменения</Modal.Heading>
            </Modal.Header>
            <Modal.Body>
              <p className="help-settings-delete__text">{discardText}</p>
            </Modal.Body>
            <Modal.Footer className="help-settings-footer">
              <Button variant="ghost" onPress={handleDiscardDismiss}>
                Остаться
              </Button>
              <Button
                variant="secondary"
                onPress={() => {
                  helpSettingsStore.confirmDiscard();
                }}
              >
                Без сохранения
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </>
  );
});

HelpSettingsModals.displayName = "HelpSettingsModals";
export default HelpSettingsModals;
